








































































































import _ from "lodash";
import rest from "@/rest";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";
import { List, Enumerable } from 'linq-collections';

// Import pdfmake-wrapper and the fonts to use
import { ICreatePDF, PdfMakeWrapper } from 'pdfmake-wrapper';
import * as pdfFonts from "pdfmake/build/vfs_fonts"; // fonts provided for pdfmake
import { Txt, IText } from 'pdfmake-wrapper';
import { Img, IImg } from 'pdfmake-wrapper';

// interfaces
import { UserCertificateVm } from "@/interfaces/UserCertificateVm";
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { vuex } from "@/store";
import { User } from "@/store/types/auth";
import moment from "moment";
import { ParamDictionary } from "@/interfaces/ParamDictionary";

const auth = namespace("auth");
const globals = namespace("globals");

@Component({
  components: {
  }
})
export default class MyCertificatesView extends Vue {
  @auth.Getter isAdmin: any;
  @auth.Getter isOrgAdmin: any;
  @auth.Getter loggedInUser: any;

  // busy = false;
  certificates: UserCertificateVm[] = [];
  filteredCertificates: UserCertificateVm[] = [];
  search: string = "";
  expandedPanelIndex: number | null = null;
  focusedPanelIndex: number | null = null;

  // $refs!: {};

  async mounted() {
    await this.updateCertificateList();
    vuex.globals.setGroup(null);
    // focus search input on load
    this.$nextTick(() => {
      const searchInput = document.getElementById('search-input') as HTMLElement;
      if (searchInput) searchInput.focus();
    });
  }

  beforeDestroy() {
    clearAllBodyScrollLocks();
  }

  @Watch("search")
  async onSearch(val) {
    if (!val || val.length == 0) {
      this.filteredCertificates = this.certificates;
      return;
    }
    // this.filteredCertificates = new List(this.certificates)
    //   .where(c => c.bundleName?.toLowerCase().includes(val.toLowerCase()) ?? false)
    //   .toArray();
    const searchValue = val?.toLowerCase() ?? "";
    this.filteredCertificates = new List(this.certificates)
      .where(c => {
        const sourceValue = c.bundleName?.toLowerCase() + " " + c.title?.toLowerCase() + " " + c.summary?.toLowerCase();
        return sourceValue.includes(searchValue) ?? false;
      })
      .toArray();
  }

  async updateCertificateList() {
    this.certificates = await rest.url("exercises/getUserCertificates").get();
    this.filteredCertificates = this.certificates;
  }

  certificateTitle(certificate: UserCertificateVm) {
    if (!certificate)
      return "";
    if (certificate.title)
      return certificate.title;
    return certificate.bundleName;
  }

  focusHeaderAfterToggle(index: number) {
    this.$nextTick(() => {
      const headers = this.$el.querySelectorAll('.v-expansion-panel-header');
      const header = headers[index] as HTMLElement | undefined;
      if (header && typeof header.focus === 'function') {
        this.focusedPanelIndex = index;
        header.focus();
      }
    });
  }

  handlePanelBlur(index: number, event: FocusEvent) {
    const nextTarget = event.relatedTarget as Node | null;
    const currentPanel = event.currentTarget as HTMLElement | null;

    // Clear highlight only when focus actually leaves this panel.
    if (!currentPanel || !nextTarget || !currentPanel.contains(nextTarget)) {
      if (this.focusedPanelIndex === index) {
        this.focusedPanelIndex = null;
      }
    }
  }

  onLoadAllCertificatsPdf() {
    let params: ParamDictionary = { dictionary: {} };
    params.dictionary!["startDate"] = "";
    params.dictionary!["endDate"] = "";
    this.$globalHelper.blobDownloadWithAuth("api/exercises/loadUserCertificatesPdf", `${new Date().toISOString().substring(0, 10)}-${this.loggedInUser}-Zertifikate.pdf`, params);
  }

  // async onLoadPdf(certificate: UserCertificateVm) {
  //   let pdf = await this.createPdfDocument(certificate);
  //   pdf.create().download(`Zertifikat - ${this.certificateTitle(certificate)}.pdf`);
  // }

  // async onPrintPdf(certificate: UserCertificateVm) {
  //   let pdf = await this.createPdfDocument(certificate);
  //   pdf.create().print();
  // }

  onLoadSingleCertificatePdf(certificate: UserCertificateVm) {
    let params: ParamDictionary = { dictionary: {} };
    params.dictionary!["UserId"] = certificate.userId!;
    params.dictionary!["BundleId"] = certificate.exBundleId.toString() ?? "0";
    params.dictionary!["GroupId"] = "0"; // Will be ignored if user is loading his own certificate
    params.dictionary!["PdfFileName"] = certificate.pdfFileName ?? "";

    this.$globalHelper.blobDownloadWithAuth("api/exercises/loadSingleCertificatePdf", `${certificate.firstName} ${certificate.lastName}-${certificate.bundleName}-Zertifikat.pdf`, params);
  }

  // async createPdfDocument(certificate: UserCertificateVm): Promise<PdfMakeWrapper> {
  //   // Docu: https://pdfmakewrapper.org/docs/getting-started/essential-concepts/main-classes; https://github.com/Lugriz/pdfmake-wrapper
  //   //       https://pdfmakewrapper.org/docs/api-references/document-definition
  //   //       https://github.com/bpampuch/pdfmake; https://pdfmake.github.io/docs/
  //   // vue to pdf: https://github.com/mizuka-wu/vue-pdfmake

  //   // Set the fonts to use
  //   PdfMakeWrapper.setFonts(pdfFonts);

  //   // Define document
  //   const pdf = new PdfMakeWrapper();
  //   pdf.pageSize('A4'); // A4 paper is 595.35 x 841.995 pt. Since A4 is 210 x 297 mm => 1 mm = 2.835 pt
  //   // pdf.pageMargins([ 40, 60, 40, 60 ]);
  //   pdf.info({
  //     title: 'Zertifikat',
  //     author: 'L3RN online',
  //     subject: this.certificateTitle(certificate) ?? "",
  //   });
  //   let def = pdf.getDefinition();
  //   // console.log("doc definitions:", def);

  //   // Set Background image
  //   const backgroundImage: IImg = await new Img('Zertifikat.png').fit([595.35, 841.995]).build();
  //   pdf.background(backgroundImage);

  //   // Winner image
  //   // const winner: IImg = await new Img('82-winner.png').fit([200, 300]).alignment("center").absolutePosition(180, 200).build();
  //   // pdf.add(winner);

  //   // User name
  //   // let text = new Txt([
  //   //   new Txt(`${certificate.firstName} ${certificate.lastName}\n\n`).bold().fontSize(24).color("#4089be").end,
  //   //   new Txt("hat die Schulung\n").fontSize(18).color("#494949").end,
  //   //   new Txt(`${certificate.bundleName}\n`).bold().fontSize(24).color("#4089be").end,
  //   //   new Txt(`am ${moment(certificate.closingDate).format("DD.MM.yyyy")}\ erfolgreich absolviert.`).fontSize(18).color("#494949").end,
  //   // ]).alignment("center").lineHeight(1.5).absolutePosition(180,350).end;

  //   let textArray = [
  //     new Txt(`${certificate.firstName} ${certificate.lastName}\n\n`).bold().fontSize(24).color("#4089be").end,
  //     new Txt("hat die Schulung\n").fontSize(18).color("#494949").end,
  //     new Txt(`${this.certificateTitle(certificate)}\n`).bold().fontSize(24).color("#4089be").end,
  //     new Txt(`am ${moment(certificate.closingDate).format("DD.MM.yyyy")}\ erfolgreich absolviert.`).fontSize(18).color("#494949").end,
  //   ];

  //   if (certificate.comment && certificate.comment.length > 0)
  //     textArray.push(new Txt(`\n\n${certificate.comment}`).fontSize(12).color("#494949").end);

  //   let text = new Txt(textArray).alignment("center").lineHeight(1.5).absolutePosition(180,350).end;
  //   pdf.add(text);

  //   if (certificate.signature && certificate.signature.length > 0) {
  //     const signature = (await new Img(certificate.signature).width(180).absolutePosition(180, 650).build()); //alignment("center").absolutePosition(180, 500);
  //     pdf.add(signature);
  //     let name = new Txt(`${certificate.firstName} ${certificate.lastName}`).fontSize(14).color("#494949").absolutePosition(210, 710).end;
  //     pdf.add(name);
  //   }

  //   // L3RN online
  //   // const l3rnOnline = new Txt([
  //   //   new Txt("L").color("#494949").end,
  //   //   new Txt("3").bold().color('#0C8AAD').end,
  //   //   new Txt("RN online").color("#494949").end,
  //   // ]).absolutePosition(480,785).end;
  //   // pdf.add(l3rnOnline);

  //   return pdf;
  // }

  formatDate(date) {
    if (date == null)
      return "-";

    return moment(date).format("DD.MM.yyyy");
  }

  // Accessibility: keyboard navigation among certificate items
  handleKeyNavigation(event: KeyboardEvent, currentIndex: number) {
    if (!this.filteredCertificates || this.filteredCertificates.length === 0) return;

    let targetIndex = -1;

    switch (event.key) {
      case 'ArrowDown':
      case 'ArrowRight':
        event.preventDefault();
        targetIndex = currentIndex + 1;
        if (targetIndex >= this.filteredCertificates.length) {
          targetIndex = 0; // wrap to first
        }
        break;

      case 'ArrowUp':
      case 'ArrowLeft':
        event.preventDefault();
        targetIndex = currentIndex - 1;
        if (targetIndex < 0) {
          targetIndex = this.filteredCertificates.length - 1; // wrap to last
        }
        break;

      case 'Home':
        event.preventDefault();
        targetIndex = 0;
        break;

      case 'End':
        event.preventDefault();
        targetIndex = this.filteredCertificates.length - 1;
        break;

      case 'Enter': {
        // Optional: Enter could trigger download for the focused certificate
        event.preventDefault();
        const cert = this.filteredCertificates[currentIndex];
        if (cert) this.onLoadSingleCertificatePdf(cert);
        return;
      }

      default:
        return; // do nothing for other keys
    }

    this.focusListItem(targetIndex);
  }

  focusListItem(index: number) {
    this.$nextTick(() => {
      const headers = this.$el.querySelectorAll('.v-expansion-panel-header');
      const header = headers[index] as HTMLElement | undefined;
      if (header && typeof header.focus === 'function') {
        this.focusedPanelIndex = index;
        header.focus();

        // Announce current position for screen readers
        const current = this.filteredCertificates[index];
        const name = current?.bundleName || 'Unbekanntes Zertifikat';
        this.announceToScreenReader(`${name}, Position ${index + 1} von ${this.filteredCertificates.length}`);
      }
    });
  }

  announceToScreenReader(message: string) {
    let announcement = document.getElementById('page-announcements');
    if (!announcement) {
      announcement = document.createElement('div');
      announcement.id = 'page-announcements';
      announcement.setAttribute('aria-live', 'polite');
      announcement.setAttribute('aria-atomic', 'true');
      announcement.className = 'sr-only';
      document.body.appendChild(announcement);
    }

    announcement.textContent = message;
    setTimeout(() => {
      announcement!.textContent = '';
    }, 1200);
  }

  get focusStyle() {
    return {
      '--focus-border-color': this.$store.state.ux.colorAccent,
      '--focus-bg-color': this.$store.state.ux.colorAccent + '10' // softer, more transparent background highlight
    };
  }
}
